import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import StepRangeSlider from 'react-step-range-slider';
import { action, toJS } from "mobx";
import Form, { FormBody, DateInput, SelectInput, FormActions } from "../../../Form";
import { getDisplayDate, utc } from '../../../../libs/date';
import { BASE_URL } from "../../../../config";
import LeafletMap from '../../../LeafletMap';
import ImageSlider from '../../../ImageSlider';

@inject("stationImageStore", 'imageTagStore')
@observer
class Search extends Component {

	state = {
		// date_from: getDisplayDate(moment().subtract(1, "day").startOf("day"), { format: "YYYY-MM-DD" }),
		// date_to: getDisplayDate(moment().endOf("day"), { format: "YYYY-MM-DD" }),
		date_from: moment().subtract(6, 'hours').format('YYYY-MM-DDTHH:mm:ss'),
		date_to: moment().format('YYYY-MM-DDTHH:mm:ss'),
		// date_from: '2021-09-23T00:00:00',
		// date_to: '2021-09-24T00:00:00',
		albums: [],
		selectedAlbum: 'Panoramic',
		filter_date: 'date_taken',
		currentImage: null
	};

	componentDidMount() {
		this.props.stationImageStore.fetchAlbums(this.props.params.id);
		this.fetchData();
	}

	fetchData = (e) => {
		if (e)
			e.preventDefault();

		const { date_from, date_to, filter_date } = this.state;
		const { params: { id } } = this.props;

		this.props.stationImageStore.fetchStationImages({
			station_id: id,
			date_from: utc(date_from),
			date_to: utc(date_to), // getDisplayDate(date_to, { format: "YYYY-MM-DDTHH:mm:SS" }),
			filter_date
		});
	}

	handleDateChange = (e) => {
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	handleFilterDateChange = (e) => {
		this.setState({
			filter_date: e.target.value
		});
	}

	handleAlbumChange = (e) => {
		this.props.stationImageStore.setSelectedAlbum(e.target.value);
	};

	onChangeSelectedImage = image => this.setState({ currentImage: image });

	getDirectionRange = image => {
		let direction = Math.min(+image.direction, +image.direction_end),
			direction_end = Math.max(+image.direction, +image.direction_end);
		if (!direction && !direction_end && direction !== 0 && direction_end !== 0) return [];
		if (direction === direction_end) return ['', direction, ''];
		let diff = (direction_end - direction) / 4, range = [];
		let initial = direction;
		while (initial <= direction_end) {
			range.push(Math.floor(initial));
			initial += diff;
		}
		return range;
	}

	_renderMap = (image) => {
		if (!image.latitude || !image.longitude) return null;

		const center = { lat: image.latitude, lng: image.longitude }
		return <LeafletMap
			id={`station-${image.file_name}-field-of-view`}
			center={center} zoom='14'
			markers={[]}
			height='300px' width='100%'
			circle={{ latLng: center, radius: 1000, startAngle: image.direction, stopAngle: image.direction_end }}
		/>
	}

	render() {
		const { date_from, date_to, filter_date, currentImage } = this.state;
		const { selectedAlbum, stationAlbums, stationImagesFilteredBySelectedAlbum } = this.props.stationImageStore;

		return (
			<div>
				<Form>
					<FormBody>
						<DateInput type="datetime-local" label={'Date From'} name={"date_from"} value={date_from} onChange={this.handleDateChange} />
						<DateInput type="datetime-local" label={'Date To'} name={"date_to"} value={date_to} onChange={this.handleDateChange} />
						{/* <SelectInput label={'Filter Date'} value={filter_date} fields={{label: 'label', value: 'value'}} options={filterDateOptions} onChange={this.handleFilterDateChange} /> */}
						<SelectInput label={'Album'} value={selectedAlbum} fields={{ label: 'album_code', value: 'album_code' }} options={stationAlbums} onChange={this.handleAlbumChange} defaultValue={'All'} />
					</FormBody>
					<FormActions>
						<button onClick={this.fetchData}>Go</button>
					</FormActions>
				</Form>

				<div className='inline-grid v-center' >
					<div className='flex-grow'>
						{currentImage && <div className='flex flex-row space-between full-width'>
							{this.getDirectionRange(currentImage).map((item, key) => (<span key={`imagge-direction-${key}-${item}`} >{item}</span>))}
						</div>}
						<ImageSlider baseUrl={`${BASE_URL}/idaq-files`} images={stationImagesFilteredBySelectedAlbum} onChangeImage={this.onChangeSelectedImage} filterKey={filter_date} />
					</div>
					{currentImage && <div className='ticket-follower'>
						<div className='bordered'>
							<div className='DataTable'>
								<table>
									<tbody>
										<tr><th>Album</th><td>{currentImage.album_code}</td></tr>
										<tr><th>Date Taken</th><td>{getDisplayDate(currentImage.date_taken)}</td></tr>
										<tr><th>Date Created</th><td>{getDisplayDate(currentImage.date_created)}</td></tr>
										<tr><th>Date Modified</th><td>{currentImage.date_modified && getDisplayDate(currentImage.date_modified)}</td></tr>
										<tr><th>Status</th><td>{currentImage.status}</td></tr>
										<tr><th>Rating</th><td>{currentImage.rating}</td></tr>
										<tr><th>Lat, Long</th><td>{currentImage.latitude}, {currentImage.longitude}</td></tr>
										<tr><th>File Name</th><td>{currentImage.file_name}</td></tr>
									</tbody>
								</table>
							</div>
						</div>
						<br />
						{this._renderMap(currentImage)}
					</div>}
				</div>
			</div>
		);
	}
}

export default Search;


// WEBPACK FOOTER //
// ./src/components/Station/Image/pages/Search.js